import { useMemo } from "react";
import { useQuery } from "react-query";
import { createMagentoClient, getDiscount, getDiscountBySKU, getPrice, getStockStatus, } from "@jti/magento";
import { useConfig } from "../useConfig";
const getColorsForConfigurableProduct = (productData) => {
    if (productData.__typename === "ConfigurableProduct") {
        return productData?.configurable_options?.[0]?.values?.map((value) => value?.swatch_data?.value).filter(Boolean);
    }
    return [];
};
export const useProductsDynamicData = ({ productsSkus, isTrial = false }) => {
    const config = useConfig();
    const magentoClient = createMagentoClient({ isTrial, config });
    const { data: productResponseData, isFetching, isSuccess, } = useQuery({
        queryKey: ["PRODUCT_ESSENTIAL_QUERY", productsSkus, { isTrial }],
        enabled: productsSkus.length > 0,
        queryFn: () => {
            return magentoClient.getProductsEssentialsBySku(productsSkus, productsSkus.length);
        },
    });
    const currency = productResponseData?.currency?.base_currency_code;
    const products = useMemo(() => {
        const productsData = productResponseData?.products?.items ?? [];
        return productsData.reduce((acc, productData) => {
            const productType = productData?.__typename;
            const isConfigurableProduct = productType === "ConfigurableProduct";
            const priceInformation = getPrice(productData.sku, productData.sku, productData);
            const isInStock = getStockStatus(isConfigurableProduct ? productData.variants[0]?.product?.sku : productData.sku, productData);
            const discount = isConfigurableProduct
                ? getDiscountBySKU(productData.sku, productData)
                : getDiscount(productData);
            const colors = getColorsForConfigurableProduct(productData);
            acc[productData.sku] = {
                isInStock,
                currentPrice: priceInformation.finalPrice?.value,
                oldPrice: priceInformation.price?.value,
                discount,
                productData: {
                    name: productData?.name,
                    image: productData?.thumbnail.url,
                    description: productData?.short_description.html,
                    colors,
                },
            };
            return acc;
        }, {});
    }, [productResponseData]);
    return {
        isProductsDataLoading: isFetching,
        isProductsDataLoaded: !isFetching && isSuccess,
        products,
        currency,
    };
};
//# sourceMappingURL=useEssentialProductData.js.map